import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { rememberPostLoginRedirect } from '../../utils/postLoginRedirect';

/** Sends a signed-out user to /login, first remembering the current page (only allowed targets,
 *  such as the AI-app consent page, are kept) so sign-in can return to it. */
const LoginRedirect: React.FC = () => {
    // The page is captured during render: <Navigate>'s own effect runs before this one (child
    // first) and has already moved the browser to /login by then. The storage write itself stays
    // in an effect, out of render (StrictMode double renders, discarded renders).
    const { pathname, search } = useLocation();
    useEffect(() => {
        rememberPostLoginRedirect(pathname + search);
    }, [pathname, search]);
    return <Navigate to="/login" replace />;
};

export default LoginRedirect;
